<template>
  <fb-list-body :showPager="false">

    <template slot="btn-group">
      <el-button @click.native="handleSaveSubmit">{{$t('保存更改')}}</el-button>
    </template>

    <template slot="search-form">
      <el-form-item :label="$t('分类名称')">
        <el-input :placeholder="$t('分类名称')" v-model="searchForm.name" clearable/>
      </el-form-item>

      <el-form-item>
        <el-button type="primary" @click="$refs.list.handleSearch()">{{$t('搜索')}}</el-button>
        <el-button @click="$refs.list.reset()">{{$t('重置')}}</el-button>
      </el-form-item>
    </template>

    <template slot="table">

      <table-list
          ref="list"
          row-key="id"
          @query="handleSearch"
          :search-params="searchForm"
          :data="tableData"
          :indent="16"
          @selection-change="selection = $event">

        <el-table-column type="selection" width="50"/>

        <el-table-column prop="name" :label="$t('分类名称')"/>
        <el-table-column prop="phone" :label="$t('是否显示')">
          <template v-slot="{row}">
            <el-switch  inactive-value="no" active-value="yes" v-model="row.display" />
          </template>
        </el-table-column>
      </table-list>
    </template>
  </fb-list-body>
</template>

<script>
import {request} from "@/config/request";
import TableList from "@/components/table-list/TableList";

export default {
  name: "ShowCategory",
  components: {TableList},
  data() {
    return {
      searchForm: {},
      tableData: [],
      selection: [],
    }
  },
  methods: {
    // 保存修改
    async handleSaveSubmit() {
      try {
        const params = this.tableData.map(i => {
          return {
            name: i.name,
            code: i.code,
            display: i.display
          }
        })
        await request(this.$api.cookbookSort.saveOne, params, {isJson: true});
        this.$message.success(this.$t('操作成功'));
      }catch(e) {
         console.log(e);
      }
    },

    async handleSearch(params) {
      try {
        let res = await request(this.$api.cookbookSort.listOne, params);
        for (let key in res) {
          if (res[key] instanceof Array) {
            this.tableData = res[key];
          }
        }
        if (this.$refs?.list) {
          this.$refs.list.setTotal(res.pager?.itemCount);
        }
      } catch (e) {
        console.error(e);
      }
    }
  },
}
</script>

<style scoped>

</style>
